import {ofType} from 'redux-observable';
import {concat, iif, mergeMap, of} from 'rxjs';
import {ajax} from 'rxjs/ajax';
import {catchError, timeout} from 'rxjs/operators';
import {AnyAction} from 'redux';
import * as ProfileActions from '../actions/ProfileActions';
import * as UIActions from '../actions/UIActions';
import * as WizardMXActions from '../actions/WizardMXActions';
import * as SecuritySSOConstants from '../constants/SecuritySSOConstants';
import * as StateConstants from '../constants/StateConstants';
import {push} from 'connected-react-router';
import * as WizardActions from '../actions/WizardActions';
import * as LoginActions from '../actions/LoginActions';
import * as MC from '../constants/MotorcreditConstants';
import * as ErrorConstants from '../constants/ErrorConstants';
import * as CookieUtils from '../../common/utils/CookieUtils';

export const getInfoProfileFederatedEpic = (action$, state$) =>
    action$.pipe(
        ofType(LoginActions.SSO_GOT_TOKEN_BY_CODE.name),
        mergeMap((action: AnyAction) => {
            const url = `${SecuritySSOConstants.SECURITY_URL}/end-user-profile/user-info-federated`;
            const headers = {
                'access-token': action.accessToken,
                domain: SecuritySSOConstants.getKCClient(state$.value.countrySelector.countrySelected),
                'login-url': SecuritySSOConstants.getSSOAuthorizationUrl(state$.value.countrySelector.countrySelected)
            };
            return concat(
                of(UIActions.IS_LOADING_ACTION.action(LoginActions.SSO_GOT_TOKEN_BY_CODE.name)),
                ajax.get(url, headers).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap((response: any) => {
                        const data = response.response.data;
                        let pathToRedirect = state$.value.login.pathToRedirect;
                        if (pathToRedirect === null || pathToRedirect === '') {
                            pathToRedirect = CookieUtils.getCookie(StateConstants.PATH_TO_REDIRECT);
                        }
                        return concat(
                            of(UIActions.IS_LOADED_ACTION.action(LoginActions.SSO_GOT_TOKEN_BY_CODE.name)),
                            of(ProfileActions.GOT_PROFILE_INFO_ACTION.action(data.userId, data.email,
                                data.firstName, data.lastName, data.groups, data.roles)),
                            of(WizardActions.CHANGE_FIRST_NAME_ACTION.action(data.firstName, null)),
                            of(WizardActions.CHANGE_LAST_NAME_ACTION.action(data.lastName, null)),
                            iif(
                                () => pathToRedirect === null || pathToRedirect === '',
                                of(WizardMXActions.GO_TO_CALCULATOR_MX_ACTION.action()),
                                of(push(pathToRedirect))
                            )
                        );
                    }),
                    catchError((error) => {
                        console.log('--------------SSO_GOT_TOKEN_BY_CODE ERROR-------------- ', error);
                        const errorMessages = error.xhr.response && error.xhr.response.notifications
                            ? error.xhr.response.notifications.errorMessages : [];
                        const errorIsSecurityProviderErrorNotMappedError = Array.isArray(errorMessages) ?
                            errorMessages.includes(ErrorConstants.SSO_SECURITY_PROVIDER_ERROR_NOT_MAPPED_ERROR) : false;
                        const errorIsSecurityProviderUnknownError = Array.isArray(errorMessages) ?
                            errorMessages.includes(ErrorConstants.SSO_SECURITY_PROVIDER_UNKNOWN_ERROR) : false;
                        return concat(
                            of(UIActions.IS_LOADED_ACTION.action(LoginActions.SSO_GOT_TOKEN_BY_CODE.name)),
                            iif(
                                () => errorIsSecurityProviderErrorNotMappedError ||
                                    errorIsSecurityProviderUnknownError,
                                concat(
                                    of(UIActions.ERROR_GENERAL_ACTION.action(error, null, url, {}, 'GET')),
                                    of(LoginActions.LOGOUT_ACTION.action())
                                ),
                                of(UIActions.ERROR_GENERAL_ACTION.action(error, action, url, {}, 'GET'))
                            )
                        );
                    })
                )
            );
        })
    );
